import React from 'react';
import { CheckCircleIcon, MicIcon, FileTextIcon } from 'lucide-react';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SecondaryButton } from '../ui/SecondaryButton';
export function Screen11_PTPCreated({
  data,
  onNext,
  onBack
}: ScreenProps) {
  return <div className="flex flex-col h-full" data-id="element-431">
      <div className="mb-6" data-id="element-432">
        <h2 className="text-2xl font-bold text-white mb-2" data-id="element-433">PTP Created</h2>
        <p className="text-slate-400" data-id="element-434">
          The plan is ready. Next, record the crew PTP meeting to verify
          understanding and capture additional safety information.
        </p>
      </div>

      <div className="flex-1 overflow-y-auto pb-6 -mx-2 px-2 space-y-6" data-id="element-435">
        <div className="bg-slate-900 border border-slate-800 rounded-xl p-5 relative overflow-hidden" data-id="element-436">
          <div className="absolute top-0 right-0 bg-green-500/20 text-green-400 text-xs font-bold px-3 py-1 rounded-bl-lg flex items-center gap-1" data-id="element-437">
            <CheckCircleIcon className="w-3 h-3" data-id="element-438" />
            PTP Ready
          </div>

          <div className="space-y-4 mt-2" data-id="element-439">
            <div data-id="element-440">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-441">
                Project
              </p>
              <p className="text-white font-medium text-sm" data-id="element-442">{data.project}</p>
            </div>
            <div data-id="element-443">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-444">
                Location
              </p>
              <p className="text-white font-medium text-sm" data-id="element-445">{data.location}</p>
            </div>
            <div data-id="element-446">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-447">
                Task
              </p>
              <p className="text-yellow-400 font-bold text-sm" data-id="element-448">
                Steel Beam Installation Using Mobile Crane
              </p>
            </div>
          </div>
        </div>

        <div className="bg-slate-900/50 border border-slate-800/50 rounded-xl p-5" data-id="element-449">
          <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" data-id="element-450">
            Why record the meeting?
          </h3>
          <ul className="space-y-3" data-id="element-451">
            {['Confirm the crew understands the plan', 'Capture additional risks discussed in the field', 'Verify who participated in the briefing', 'Score meeting quality and coverage'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-452">
                <div className="w-1.5 h-1.5 rounded-full bg-yellow-500 mt-1.5 flex-shrink-0" data-id="element-453" />
                <span className="text-slate-300 text-sm leading-snug" data-id="element-454">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="pt-4 space-y-3 bg-slate-950" data-id="element-455">
        <PrimaryButton onClick={onNext} icon={<MicIcon className="w-5 h-5" data-id="element-457" />} data-id="element-456">
          Start PTP Meeting Recording
        </PrimaryButton>
        <SecondaryButton onClick={onBack} icon={<FileTextIcon className="w-5 h-5" data-id="element-459" />} data-id="element-458">
          View PTP Summary
        </SecondaryButton>
      </div>
    </div>;
}